import paper from "@/store/pages/accounts/paper";
import history from "@/store/pages/accounts/history";
import hightProfitMembers from "@/store/pages/accounts/hightProfitMembers";
import memberMonthlyProfit from "@/store/pages/accounts/memberMonthlyProfit";

export default {
  namespaced: true,
  modules: {
    accounts: {
      namespaced: true,
      modules: {
        paper,
        history,
        hightProfitMembers,
        memberMonthlyProfit,
      },
    },
  },
};
